<template>
    <div class="judge-list-wrap">
        <div class="judge-table">
            <el-table :data="tableData" border size="mini" :header-cell-style="headerCellStyle" :height="PAGESIZE.h-300" >
                <el-table-column prop="pwcode" label="评委编码" :show-overflow-tooltip="true" > </el-table-column>
                <el-table-column prop="pwname" label="姓名" > </el-table-column>
                <!-- <el-table-column prop="isdzqm" label="是否电子签名" >
                    <template slot-scope="scope">
                        <el-switch
                            size="mini"
                            :disabled="!( orderInfo.orderState == 3 || (orderInfo.orderState == 4 && (!orderInfo.auditStatus || orderInfo.auditStatus == 2) ))"
                            v-model="scope.row.isdzqm"
                            active-color="#67c23a"
                            inactive-text="否"
                            active-text="是"
                            @change="isdzqmChange(scope.row)"
                            inactive-color="#999">
                        </el-switch>
                    </template>
                </el-table-column> -->
                <el-table-column prop="" label="操作" width="180" v-if="orderInfo && (orderInfo.orderState <= 3 || (orderInfo.orderState == 4 && (!orderInfo.auditStatus || orderInfo.auditStatus == 2) ))">
                    <template slot-scope="scope">
                        <!-- <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button> -->
                        <el-button type="text" size="small" @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog :visible.sync="openDialog" width="600px" :title="title" :close-on-click-modal="false">
            <el-form label-width="100px" ref="form" :model="form" :rules="rules" size="small">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="选择评委" prop="selectIds">
                            <el-select v-model="form.selectIds" filterable size="small" :multiple="true" placeholder="请选择评委" style="width:100%">
                                <!-- <el-option v-for="item in usersData" :key="item.id" :disabled="item.id == userInfo.id" :label="item.nickname" :value="item.id">{{item.nickname}}<span v-if="item.name">({{item.name}})</span></el-option> -->
                                <el-option v-for="item in usersData" :key="item.id" :label="item.nickname" :value="item.id">{{item.nickname}}<span v-if="item.name">({{item.name}})</span></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item label="是否电子签名" prop="isdzqm">
                            <el-radio-group v-model="form.isdzqm">
                                <el-radio :label="1">是</el-radio>
                                <el-radio :label="0">否</el-radio>
                            </el-radio-group>
                        </el-form-item> -->
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="openDialog = false" size="small">取 消</el-button>
                <el-button type="primary" @click="submitForm" size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { userList } from '@/api/system/user.js'
import { getJudgeList,addJudgeSaveList,delJudge } from '@/api/srm/inquiryDetail.js';
export default {
    props:['orderInfo'],
    data(){
        return {
            tableData:[],
            openDialog:false,
            title:'',
            form:{
                id:'',
                orderId:this.$route.query.hId,
                selectIds:'',
                // isdzqm:0,
            },
            usersData:[],
            rules:{
                 selectIds: [{ required: true, message: '请选择评委',  trigger: 'blur' }],
            }
        }
    },
    mounted(){
        this.getJudgeList();
        console.log(this.userInfo)
    },
    methods:{
        // isdzqmChange(row){
        //     console.log(row)
        // },
        async getList(callback) {
            if(this.usersData.length>0){
                callback()
                return
            }
            let _this = this;
            const {
                data: res
            } = await userList({
                page: 1, //当前页码
                limit: 10000, //当前每页显示的数量
                objMap: {
                    isAuditUser: '是',
                }
            })
            if (res.code == 0) {
                _this.usersData = res.data || [];
                callback()
            }
        },
        async getJudgeList(callback) {
            let _this = this;
            const {
                data: res
            } = await getJudgeList({
                "limit": 1000,
                "objMap": {"orderId": _this.$route.query.hId},
                "page": 0
            })
            if (res.code == 0) {
                _this.tableData = res.data || [];
                _this.tableData.forEach((item)=>{
                    if(item.user){
                        item['pwname']=item.user.nickname;
                        item['pwcode']=item.user.username;
                    }
                })
            }
            return _this.tableData
        },
        // 表单重置
        reset: function() {
            this.form = {
                id:undefined,
                orderId:this.$route.query.hId,
                selectIds:[],
                // isdzqm:0,
            }
            if (this.$refs["form"] !== undefined) {
                this.$refs["form"].resetFields();
            }
        },
        // 新增
        addJudge(){
            this.getList(()=>{
                this.reset();
                this.title = '新增'
                this.openDialog = true;
            })

        },
        // 编辑
        // handleEdit:function(row){
        //     this.reset();
        //     this.form.id=row.id;
        //     this.form.code=row.code;
        //     this.form.userId=row.userId;
        //     this.title = '编辑'
        //     this.openDialog = true;
        // },
        // 删除
        handleDel:function(row){
             let _this = this;
            _this.confirm({
                text: '确认删除吗',
                tip: '警告',
                type: '',
                fn: function(param) {
                    delJudge(param).then(response => {
                        if (response.data.code === 0) {
                            _this.$success(response.data.msg);
                            _this.getJudgeList();
                        } else {
                            _this.$fail(response.data.msg);
                        }
                    });
                },
                data: {
                    id: row.id
                } //参数对象 主要回调函数用
            });
        },
        // 提交
        submitForm(){
            let _this = this;
            _this.$refs['form'].validate((valid) => {
                if (valid) {
                    let prama = [];
                    _this.form.selectIds.forEach((item)=>{
                        // prama.push({orderId: _this.form.orderId, userId:item,isdzqm:_this.form.isdzqm?true:false})
                        prama.push({orderId: _this.form.orderId, userId:item})
                    })
                    console.log(prama)
                    addJudgeSaveList(prama).then(response => {
                        if (response.data.code === 0) {
                            _this.$success(response.data.msg);
                            _this.openDialog = false;
                            _this.getJudgeList();
                        } else {
                            _this.$fail(response.data.msg);
                        }
                    });
                }
            })
        },
    },
    computed:{
        PAGESIZE:function(){
            return this.$store.getters['app/sizeInfo'];
        },
        userInfo:function(){
            return this.$store.getters['user/user'];
        },
    },
}
</script>
<style lang="sass" scoped>

</style>
